import { LightbulbIcon, MessageCircleIcon, ThumbsUpIcon } from "lucide-react"
import { Link } from "~/components/Link"
import { StatusIcon } from "~/components/icons/status"
import { Item } from "~/components/ui/item"
import type { IssueStatus } from "~/lib/enums"
import { shortRelativeTime } from "~/lib/utils"

export function SuggestionRow({
	suggestion,
	to,
	status,
	commentCount,
	createdAt,
	variant = "compact"
}: {
	suggestion: {
		title: string
		description: string | null
		friendlyId: number
		voteCount: number
	}
	to: string
	status?: IssueStatus
	commentCount?: number
	createdAt?: Date
	variant?: "compact" | "public"
}) {
	return (
		<Item
			asChild
			variant="row"
			size={variant === "compact" ? "row" : "default"}
		>
			<Link
				to={to}
				aria-label={`Open ${suggestion.title}`}
				className="group w-full flex-nowrap justify-between"
			>
				<div className="flex min-w-0 items-center gap-2">
					{variant === "compact" && (
						<>
							<LightbulbIcon className="size-5 shrink-0 text-icons" />
							<span className="font-mono text-[11px] text-text-small">
								#{suggestion.friendlyId}
							</span>
							{status && <StatusIcon status={status} />}
						</>
					)}
					<div className="min-w-0">
						<h2
							className={
								variant === "public"
									? "truncate text-lg font-medium"
									: "truncate text-sm font-medium text-text-main"
							}
						>
							{suggestion.title}
						</h2>
						<p className="line-clamp-2 text-xs text-text-sub">
							{suggestion.description || "No description"}
						</p>
					</div>
				</div>
				<div className="flex shrink-0 items-center gap-3 text-xs text-text-small">
					{createdAt && (
						<span className="hidden sm:inline">
							{shortRelativeTime(createdAt)} ago
						</span>
					)}
					<span className="inline-flex items-center gap-1">
						<ThumbsUpIcon className="size-4" />
						{suggestion.voteCount}
					</span>
					{commentCount !== undefined && (
						<span className="inline-flex items-center gap-1">
							<MessageCircleIcon className="size-4" />
							{commentCount}
						</span>
					)}
				</div>
			</Link>
		</Item>
	)
}
